import React, { useState } from 'react';
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

function ExportTable({ loadFilteredData }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
      <button onClick={toggle} className="common-button">
        <i className="bx bx-printer mr-1" />
        Export Table
      </button>
      <DropdownMenu className="px-2">
        <DropdownItem className="rounded" onClick={() => loadFilteredData('pdf')}>
          <i className="bx bx-file-blank mr-1" />
          PDF
        </DropdownItem>
        <DropdownItem className="rounded" onClick={() => loadFilteredData('excel')}>
          <i className="bx bx-spreadsheet mr-1" />
          EXCEL
        </DropdownItem>
        <DropdownItem className="rounded" onClick={() => loadFilteredData('stata')}>
          <i className="bx bx-data mr-1" />
          STATA
        </DropdownItem>
        <DropdownItem className="rounded" onClick={() => loadFilteredData('spss')}>
          <i className="bx bx-analyse mr-1" />
          SPSS
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}

export default ExportTable;
